<template>
  <div id="Photos">
    <jw-navigation>
      <banner></banner>
      <div style="width: 100%;display: flex;flex-direction: row;justify-content: start;padding: 10px;flex-wrap: wrap;">
        <div v-for="(photo,index) in photoList" :key="index" style="width: 24%;background-color: #FFFFFF;border-radius: 5px;cursor: pointer;margin-bottom: 10px;margin-right: 10px;" @click="onClickPhoto(photo)">
          <img :src="photo['url']" style="width: 100%;height: 180px;object-fit: contain;border-top-left-radius: 5px;border-top-right-radius: 5px;">
        </div>
      </div>

      <div style="text-align: center;margin-top: 10px;">
        <Page
            @on-change="handlePageChangeAction"
            @on-page-size-change="handlePageSizeChangeAction"
            :total="totalCount"
            :page-size="pageSize"
            show-sizer
        />
      </div>
    </jw-navigation>

    <Modal
        v-model="showDrawer"
        width="50%"
        footer-hide
        class-name="vertical-center-modal">
      <img :src="showPhoto.url" style="width: 100%;margin-top: 20px;">
    </Modal>
  </div>
</template>

<script>
import Banner from "@/views/web/home/components/Banner.vue";
import {getPhotoList} from "@/request/web/photos";

export default {
  name: "Photos",
  // 注册组件
  components: {
    Banner
  },
  data() {
    return {
      showDrawer: false,
      showPhoto: {},
      albumInfo: {},
      photoList: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      filter: {}
    }
  },
  created() {
    this.onGetPhotoList()
  },
  methods: {
    onClickPhoto(photo) {
      this.showPhoto = photo
      this.showDrawer = true;
    },
    handlePageChangeAction(pageIndex) {
      this.pageIndex = pageIndex;
      this.onGetPhotoList()
    },
    handlePageSizeChangeAction(size) {
      this.pageIndex = 1;
      this.pageSize = size;
      this.onGetPhotoList()
    },
    onGetPhotoList() {
      this.filter.album_id = this.$route.params.albumId;

      getPhotoList({pageIndex: this.pageIndex, pageSize: this.pageSize, filter: this.filter}).then(res=> {
        let { list, total_count } = res.data.data;
        this.totalCount = total_count;
        this.photoList = list
      })
    }
  }
}
</script>

<style scoped>
.vertical-center-modal{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
